import Vue from 'vue'
import Router from 'vue-router'
import store from '@S'
import routes from './routes'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  routes: routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.keepAlive) {
    store.commit('common/setKeepAlivePage', {
      name: to.name
    })
    to.meta.fromPath = from.path
  }
  next()
})
routes[0].children.forEach(m => {
  if (m.meta && m.meta.keepAlive) {
    store.commit('common/setKeepAlivePage', {
      name: m.name
    })
    store.commit('common/setKeepAliveRoutes', m)
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js